@if (info(); as unitSettingInfo) {
  <div class="unit-setting-info">
    <button type="button" class="unit-setting-info-trigger" (click)="toggleDetails()">
      {{ unitSettingInfo.summary }}
    </button>

    @if (showDetails()) {
      <div class="unit-setting-info-panel">
        <div class="unit-setting-info-row">
          <strong>Display</strong>
          <span>{{ unitSettingInfo.displayDetail || 'No timetable' }}</span>
        </div>
        <div class="unit-setting-info-row">
          <strong>LED</strong>
          <span>{{ unitSettingInfo.ledDetail || 'No timetable' }}</span>
        </div>
      </div>
    }
  </div>
}
